import { render, staticRenderFns } from "./ViewOpportunityBantDataPopUp.vue?vue&type=template&id=12da9cad&scoped=true&"
import script from "./ViewOpportunityBantDataPopUp.vue?vue&type=script&lang=js&"
export * from "./ViewOpportunityBantDataPopUp.vue?vue&type=script&lang=js&"
import style0 from "./ViewOpportunityBantDataPopUp.vue?vue&type=style&index=0&id=12da9cad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12da9cad",
  null
  
)

export default component.exports